export default __webpack_public_path__ + "static/montserrat-v15-latin-700-e06b80ee5bc60052c0bcaf11d5a7ffba.ttf";